import httpClient from "./httpClient";

export const authApi = {
  login: (credentials) => httpClient.post("/login", credentials),
  checkAuth: () => httpClient.get("/check-auth"),
  logout: () => httpClient.post("/logout"),
};
